import { Epic } from 'redux-observable'
import { tag } from 'rxjs-spy/operators/tag'
import { filter, map, mergeMap, pluck } from 'rxjs/operators'
import { isOfType } from 'typesafe-actions'
import { EpicDependencies, RootState } from 'src/state/types'
import { downloadBase64 } from 'utils/fileUtils'
import { ENDPOINTS } from './constants'
import { emailApiEvents, EmailEvent, InvoicePDFResponse } from './state'

export const apiDownloadInvoicePdf: Epic<EmailEvent, EmailEvent, RootState, EpicDependencies> = (
  action$,
  state$,
  { get, catchRestError },
) =>
  action$.pipe(
    filter(isOfType(emailApiEvents.invoicePdf_request.type)),
    mergeMap(action =>
      get(ENDPOINTS.INVOICE_PDF, state$, action.payload).pipe(
        pluck('response'),
        map((res: InvoicePDFResponse) => {
          downloadBase64(res.pdfBase64, 'application/pdf', `INV-${action.payload.invoiceNumber}.pdf`)
          return emailApiEvents.invoicePdf_success(res)
        }),
        catchRestError(action),
      ),
    ),
    tag('email/epics/apiDownloadInvoicePdf'),
  )
